export default __webpack_public_path__ + "static/media/ig.617454b3.svg";